import * as React from "react"

import { GlobalState } from "../../../../../../store"
import { attachmentSelector } from "../../../../../resources/adapters"
import { fetchAttachment } from "../../../../../resources/thunks"
import { isNumber } from "../../../../../../util/Strings"
import { prefixUrl } from "../../../../../../util/UrlGenerator"
import { useAppDispatch, useAppSelector } from "../../../../../../hooks"

import Link from "../Link"
import UnavailableLink from "../UnavailableLink"

interface Props {
    attributes: Record<string, string>
    label: string
    customLabel: string
    linkParameters: string[]
}

export const AttachmentInternalLink = ({
    attributes,
    customLabel,
    label,
    linkParameters,
}: Props): JSX.Element => {
    // ATTACHMENT.[ATTACHMENTID] => DOWNLOADS THE GIVEN ATTACHMENT
    // TODO: check if exists
    // TODO: get attachment filename
    if (linkParameters.length === 2 && isNumber(linkParameters[1])) {
        const attachmentId = parseInt(linkParameters[1])

        const dispatch = useAppDispatch()
        const resources = useAppSelector(
            (state: GlobalState) => state.resources,
        )
        const attachment = attachmentSelector.selectById(
            resources,
            attachmentId,
        )

        React.useEffect(() => {
            if (!attachment) {
                dispatch(fetchAttachment(attachmentId))
            }
        }, [])

        if (!attachment) {
            return (
                <UnavailableLink
                    attributes={attributes}
                    label={label}
                    isLoading={true}
                />
            )
        } else if (attachment?.doesExist) {
            const isItemUrl =
                (attachment.filename.startsWith("http") ||
                    attachment.filename.startsWith("www.")) &&
                attachment.fileSize === "0"

            // the filename for the attachment is the actual file name
            // while for an item url it is the url
            const href = isItemUrl
                ? prefixUrl(attachment.filename)
                : `download/attachment/${attachmentId}`

            // itemurls point to an external url
            const prependApplicationPath = !isItemUrl

            // in case of the item url, we keep the internal link as the label
            // and for the attachments we use the filename
            const attachmentLabel = isItemUrl ? label : attachment.filename

            // we only show the label if there is no custom label
            const linkLabel =
                customLabel.length > 0 ? customLabel : attachmentLabel

            return (
                <Link
                    attributes={attributes}
                    label={linkLabel}
                    href={href}
                    prependApplicationPath={prependApplicationPath}
                    target="_blank"
                    rel="noreferrer"
                />
            )
        }
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default AttachmentInternalLink
